/**
 * @param {string} url
 * @param {object} options
 * @param {boolean} [options.lead=false]
 * @param {boolean} [options.end=true]
 */
export default (url, options) => {
    options = {
        lead: false,
        end: true,
        ...options,
    };

    if (url.length === 0) return url;
    if (options.lead && url.charAt(0) === '/') url = url.slice(1);
    if (options.end && url.charAt(url.length - 1) === '/') url = url.slice(0, -1);

    return url;
};
